import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { Form, Tag, Spin } from 'antd';
import { useAuthHeader } from '../../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import Params from '../../../../../Types/ParamsPicklist';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import Datas from '../../../../../Data/Data.json';
import SelectMultipleOptionPanier from '../../../../SelectMultipleOptionPanier';

let searchOperat: Params = {
  CodeAgence: '',
  Table: 'OPERAT',
  Colonne1: 'CODOPE',
  Colonne2: 'LIBELL',
  Colagence: '101',
  Choix: 22,
};

function Tab3(props: { form?: any; disabled?: boolean }) {
  const authHeader = useAuthHeader();
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);
  const [loading, setLoading] = useState(false);
  const [pageIsLoad, setPageIsLoad] = useState(true);

  const codeFrais = Form.useWatch('CodeFrais', props.form) || [];

  // Charger les options (opérations) une seule fois
  useEffect(() => {
    if (pageIsLoad) {
      setPageIsLoad(false);
      setLoading(true);
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.AnySearch,
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader(),
          CypherSearch: Crypter.encrypt(JSON.stringify(searchOperat)),
        },
      };
      axios(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode === 200) {
              const datas = res.Result.Table;
              const opts = datas.map((data: any) => ({
                value: data[Object.keys(data)[1]],
                label: `${data[Object.keys(data)[0]]} - ${data[Object.keys(data)[1]]}`,
              }));
              setOptions(opts);
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    }
  }, [pageIsLoad, authHeader]);

  const getLabel = (code: string) => {
    const found = options.find((opt) => opt.value === code);
    return found ? found.label : code;
  };

  // Si le composant est désactivé (lecture seule), on affiche les tags
  if (props.disabled) {
    return (
      <div className="tabItem">
        <Box fontStyle="inherit" className="border" width="85%" position="absolute" p={2}>
          <Typography variant="subtitle1" color="textSecondary">Frais de gestion</Typography>
          <Spin spinning={loading}>
            <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
              {codeFrais.length > 0 ? (
                codeFrais.map((code: string) => (
                  <Tag color="blue" key={code}>
                    {getLabel(code)}
                  </Tag>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">Aucun frais sélectionné</Typography>
              )}
            </Box>
          </Spin>
        </Box>
      </div>
    );
  }

  // Mode édition : on utilise le sélecteur multiple
  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width="85%" position="absolute">
        <Grid item xs={12} md={12} lg={12}>
          <SelectMultipleOptionPanier
            form={props.form}
            Size="large"
            width={4}
            label="Frais de gestion"
            name="CodeFrais"
            Parametre={searchOperat}
          />
        </Grid>
      </Box>
    </div>
  );
}

export default Tab3;